export default "__VITE_ASSET__BOMl6_hs__"